import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { AGENTIC_ORCHESTRATOR_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { workflowDefinitionColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { useHasSystemAccess } from '@Contexts/session/useHasSystemAccess';
import { EnumFrontendLayoutSetting, type ApiWorkflowDefinition } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { WorkflowDefinitionsRepository } from '@Repositories/AgenticOrchestrator';

export function FrameListWorkflowDefinition() {
    const { loadPage } = useListApi(WorkflowDefinitionsRepository, AGENTIC_ORCHESTRATOR_API);

    const hasPermission = useHasPermission();
    const hasSystemAccess = useHasSystemAccess();

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiWorkflowDefinition>
            layoutSettingsContext={EnumFrontendLayoutSetting.WorkflowDefinitionsTableLayout}
            name="WorkflowDefinitionsList"
            columns={workflowDefinitionColumns}
            initialSorting={{ columnName: 'definition_key', direction: 'asc' }}
            loader={loadPage}
            canCreate={hasSystemAccess && hasPermission(Permission.AgenticOrchestratorWorkflowDefinitionsCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
